import get from '../helpers/get';

const impressionHistory = {};

export const TRACK_EVENT = 'TRACK_EVENT';

export const trackEventCreator = link => ({
  type: TRACK_EVENT,
  payload: {
    url: get(link, ['url']),
    event: get(link, ['gtm', 'event']),
    category: get(link, ['gtm', 'category']),
    action: get(link, ['gtm', 'action']),
    label: get(link, ['gtm', 'label']),
  },
});

const base64EncodeStringMultibyteSafe = string => {
  const encoder = new global.window.TextEncoder();
  const encodedString = encoder.encode(string);
  return global.window.btoa(String.fromCharCode(...new Uint8Array(encodedString)));
};

export const trackImpressionEventCreator = cta => {
  const ctaString = JSON.stringify(cta);
  const ctaBase64 = base64EncodeStringMultibyteSafe(ctaString);

  if (impressionHistory[ctaBase64]) {
    return {
      type: TRACK_EVENT,
      payload: {},
    };
  }

  impressionHistory[ctaBase64] = 1;

  const newCTA = JSON.parse(ctaString);
  const gtmCategory = get(newCTA, ['gtm', 'category']);

  newCTA.gtm = {
    ...newCTA.gtm,
    ...{ category: `${gtmCategory} Impression` },
  };

  return trackEventCreator(newCTA);
};
